import { z } from 'zod';
/**
 * Owners manage membership and can delete the venue. Staff can do everything
 * that concerns running matches on the tables, which includes pointing a
 * camera at a match and setting where it pushes.
 *
 * The split is deliberately coarse. A club has a handful of people, and a
 * permission model finer than "can hire and fire" invites the mistake of
 * giving somebody staff access and assuming it stops them going on air.
 */
export const VENUE_ROLES = ['owner', 'staff'];
export const CreateVenueSchema = z.object({
    name: z.string().min(1).max(80),
});
export const UpdateVenueSchema = z.object({
    name: z.string().min(1).max(80),
});
export const AddVenueMemberSchema = z.object({
    /** The public id an operator can read off a colleague's profile. */
    publicId: z.string().min(1).max(60),
    role: z.enum(['owner', 'staff']).default('staff'),
});
export const VENUE_API = {
    venues: '/api/venues',
    venue: (id) => `/api/venues/${id}`,
    members: (id) => `/api/venues/${id}/members`,
    member: (id, playerId) => `/api/venues/${id}/members/${playerId}`,
};
//# sourceMappingURL=venues.js.map